import RoomsV1Adapter from './rooms-v1';

export default class RoomsV2Adapter extends RoomsV1Adapter {
  namespace = 'a/rooms-v2/api/v2';
}
